import React from 'react';

import { useParams, generatePath } from "react-router";
import {useDataValue} from 'globals/contexts/dataContext';

import LandingSection from 'containers/eventPage/landingSection';
import DetailSection from 'containers/eventPage/detailSection';
import ImageSection from 'containers/eventPage/imageSection';
// import ProjectListSection from 'containers/commercialProjectPage/projectListSection';
// import BannerSection from 'containers/eventPage/bannerSection';

import Footer from 'containers/footer';

import './indexPage.css';
import './eventPage.css';
import routes from 'globals/routes';
import { Link } from 'react-router-dom';

const EventPage = () => {
  const [{content, currentLanguage, currentEvent}, dispatch] = useDataValue();
  const {eventname} = useParams();
  if (eventname) {
    const pageContent = content['content'][currentLanguage]['pages']['experience']['event']['items'].find((item) => {
      return item['title'] === eventname;
    });
    // const itemsToProjectWrapperItem = [];
    // pageContent['items'].forEach((el, idx) => {
    //   itemsToProjectWrapperItem.push({
    //     id: idx,
    //     thumb: el['image'],
    //     caption: el['caption']
    //   })
    // });
    // thumb
    return <div id="event" className="page">
      <LandingSection content={{
        header: pageContent['title'],
        quote: pageContent['quote'],
        brief: pageContent['brief'],
        mainImage: pageContent['image'],
        month: pageContent['month'],
        scrollHints: pageContent['scrollhints'],
        buttondescription: pageContent['buttondescription'],
        buttonurl: pageContent['buttonurl'],
        buttontext: pageContent['buttontext'],
        buttonstatus: pageContent['buttonstatus'],
      }} />
      <DetailSection content={{
        title: pageContent['contenttitle'],
        media: pageContent['detailsmedia'],
        text: pageContent['detailstext'],
      }} />
      <ImageSection items={pageContent['items']} />
      <div className="backButtonRow">
        <Link to={generatePath(routes.experiencePage, { lang: currentLanguage })} className="backButton">
          {currentLanguage === 'tc'? <>返回<br/>書法體驗列表</>:<>Back to<br/>Experience</>}
        </Link>
      </div>
      <Footer />
    </div>;
  } else {
    return null;
  }
}

export default EventPage;